import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import type { Setting } from "~/modules/settings/api/settings/settingsTypes.ts";

export function indexSettings(): AxiosApiResponsePromise<Setting[]> {
	return axiosApi.get(`/settings`);
}